
const initialState = () => ({
    previous: null,
})

const mutations = {
    SET_BREADCRUMB (state, to) {
        state.previous = to
    },
}

export default {
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/breadcrumbs.js